















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model } from "vue-property-decorator";

@Component({
  components: {},
  mixins: [],
})
export default class SlideRadio extends Vue {
  /** Props */
  // ===================================================================
  @Prop({ default: 75 }) readonly width!: number;
  @Prop({ default: 47 }) readonly minHeight!: number;
  @Prop({ default: () => [] }) readonly selections!: Array<{
    icon?: string;
    label: string;
    value: any;
  }>;
  @Prop({ default: false }) readonly loading?: boolean;
  @Prop({ default: false }) readonly disabled?: boolean;

  /**
   * 选项的图标与文本横向排布
   */
  @Prop({ default: false }) readonly horizentolOpt?: boolean;

  @Model("change", { default: 0 }) value!: any;

  /** Setup */
  // ===================================================================
  //   private activeIndex = 0;

  /** Hooks */
  // ===================================================================
  mounted() {
    // if (!this.activeIndex) this.activeIndex = 0;
  }

  /** Computed */
  // ===================================================================
  get activeIndex(): number {
    for (let i = 0; i < this.selections.length; i++) {
      if (this.selections[i].value === this.value) return i;
    }
    return -1;
  }

  /** Methods */
  // ===================================================================
  handleCategoryChange(index: number): void {
    // this.activeIndex = index;
    if (this.disabled) return; // 如果是数据同步的切换，disabled 代表当前未联网
    if (this.loading) return; // 正在切换中，尚未完成，需要显示 loading 动画
    if (this.selections[index].value === this.value) return;
    this.$emit("change", this.selections[index].value);
  }
}
